// extracted by mini-css-extract-plugin
export default {"wrapper":"RadioGroup_wrapper__T9cmQ","label-text":"RadioGroup_label-text__mXX9N","children-container":"RadioGroup_children-container__DNbIg"};